export default __webpack_public_path__ + "static/media/cargando.f555f7b3.svg";